import { obterParametrosDaURL } from "../../../../functions";
import { ISolicitacaoSenha } from "../../../../interfaces";
import { api } from "../../api";
import { ApiException } from "../../api-exception";

export const ObterSolicitacaoSenhaPorId = async (
  sequencial: number
): Promise<ISolicitacaoSenha> => {
  const { token } = obterParametrosDaURL();

  try {
    const { data } = await api.get<ISolicitacaoSenha>(
      `/solicitacaosenhaporid/${sequencial}`,
      { params: { token } }
    );

    return data;
  } catch (erro) {
    throw new ApiException(erro, "Erro ao buscar solicitação de senha");
  }
};